import { useMemo } from 'react';

import { Button, Flex, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { tKeys } from '@/i18n';

import cup from '@/assets/images/cup.png';
// import SecondChanceCup from '@/assets/images/second-chance-cup.svg';
import SecondChanceCupCA from '@/assets/images/second-chance-ca.png';
import SecondChanceCupUSA from '@/assets/images/second-chance-usa.png';
import SecondChanceCupFR from '@/assets/images/second-chance-fr.png';

import { useAuth } from '@/hooks/useAuth';
import { useAuthContext } from '@/hooks/useAuthContext';

import { bracketsSecondChancePath } from '@/modules/Bracket/bracket.constants';
import { useLang } from '@/hooks/useLang';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { UserGeoPositionType } from '@/types/domain';
import { StorageKeysEnum } from '@/enums/storageKeys.enum';

export const SignupTodayBlock = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();
  const { onSignInOpen } = useAuthContext();
  const { lang } = useLang();
  const isFrench = lang === 'fr';

  const isSecondChancePage = useMemo(
    () => pathname === bracketsSecondChancePath(),
    [pathname],
  );

  const { value: geoLocation } = useLocalStorage<UserGeoPositionType>(
    StorageKeysEnum.geoPosition,
  );

  const country = geoLocation?.country;
  const isCanada = country === 'CA';

  const getSecondChanceCupImage = () => {
    if (isFrench) return SecondChanceCupFR;
    if (isCanada) return SecondChanceCupCA;
    return SecondChanceCupUSA;
  };

  return (
    <>
      <Flex align='center' direction='column' gap='20px'>
        <Image
          height='80px'
          src={isSecondChancePage ? getSecondChanceCupImage() : cup}
        />
        {!isAuthenticated && (
          <Button onClick={onSignInOpen}>{t(tKeys.signupToday)}</Button>
        )}
      </Flex>
    </>
  );
};
